<template>
    <a :href="`https://twitter.com/hkcm1/status/${data.meta.id}`" target="_blank" class="rounded-md">
        <img :src="data.meta.attachments.find((attachment) => attachment.type === 'photo').url" alt="twitter" />
    </a>
</template>

<script>
export default {
    props: ['active', 'data', 'index'],
    emits: ['update:active']
};
</script>
